import { Ticket } from '../../types/ticket';
import { Rule } from '../types/Rule';
import { RuleContext } from '../types/RuleContext';

export class SortTicketsByOrderRule implements Rule {
  apply(context: RuleContext): Ticket[] {
    const { tickets } = context;

    const sortedTickets = tickets
      .slice()
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

    return sortedTickets.map(ticket => ({
      ...ticket,
      type : ticket.type
        .slice()
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0)),
    }));
  }
}
